import { DataObject, DataObjectFactory } from "@/v2/models/base-data-object.js";
import { Parameter } from "@/v2/models/parameters.js";

export class Tier extends DataObject {
    _type = "tier";
    id;
    name;
    remark;
    bo_can_delete;
    show_action_menu;
}

export class TierMapperParameter extends Parameter {
    tierMapper;
}

export class TierFactory {
    /**
     * Creates a new instance of a DataObject.
     * @function
     * @static
     * @param {TierMapperParameter} tierMapperParameter Parameter object containing mappers that the factory expects.
     * @param {Object, null} data Data to construct the Tier object with. Also creates a Meta object using MetaFactory if data is not null.
     * @returns {Tier}
     */
    static construct(tierMapperParameter, data = null) {
        if (data != null) {
            let tier = DataObjectFactory.getInstance().construct(
                Tier,
                data ? tierMapperParameter.tierMapper(data) : null
            );

            return tier;
        }

        return null;
    }
}
